import React from 'react';
import Layout from './Layout';
import { getCourseById } from '../data/courses';
import { formatPrice, formatInstallments } from '../utils/helpers';
import cincoSegredosImg from '../images/5-segredos.png';
import './CincoSegredosPage.css';

const lessons = [
  'Segredo 1 — Como estudar aberturas de forma eficiente',
  'Segredo 2 — Cálculo e visualização: o caminho certo',
  'Segredo 3 — O pensamento estratégico na prática',
  'Segredo 4 — Finais que você precisa saber',
  'Segredo 5 — O método para evoluir de verdade',
];

const testimonials = [
  {
    name: 'Pedro Silva',
    text: '"Já consigo sentir meu xadrez melhorando, muita coisa eu já sabia, mas quando comecei, foi no intuito de fazer o curso do começo ao final, e muitas dicas que eu ainda não conhecia, estão fazendo uma diferença exponencial."',
  },
  {
    name: 'Pri Magno',
    text: '"Para quem, como eu, não sabe nada de xadrez, é uma excelente porta de entrada."',
  },
  {
    name: 'Maria Cleonice',
    text: '"Estou gostando muito!"',
  },
];

function CincoSegredosPage() {
  const course = getCourseById('5-segredos');
  const paymentUrl = course.paymentUrl;

  return (
    <Layout title="5 Segredos para Melhorar no Xadrez" favicon="/5-segredos.ico">
      {/* Hero */}
      <section className="cs-hero">
        <div className="cs-hero__inner">
          <img src={cincoSegredosImg} alt="5 Segredos para Melhorar no Xadrez" className="cs-hero__image" />
          <div className="cs-hero__content">
            <span className="cs-hero__badge">MN Isabella Conti</span>
            <h1 className="cs-hero__title">5 Segredos para Evoluir no Xadrez</h1>
            <p className="cs-hero__subtitle">
              Descubra de forma prática os 5 segredos que vão transformar seu jogo,
              evitando os dogmas e caminhos errados percorridos por muitos aprendizes.
            </p>
            <a href={paymentUrl} target="_blank" rel="noopener noreferrer" className="cs-hero__cta">
              Quero este curso
            </a>
          </div>
        </div>
      </section>

      {/* About Instructor */}
      <section className="cs-about">
        <div className="cs-about__inner">
          <h2 className="cs-about__title">Sobre a Instrutora</h2>
          <p className="cs-about__text">
            Isabella Conti é <strong>Mestre Nacional de xadrez</strong>, título conquistado no
            Campeonato Brasileiro de Duplas em 2020. Foi campeã brasileira sub 16 e campeã
            sul-americana escolar em 2018. Além de vários títulos por categorias, Isabella é
            bi-campeã mineira adulta e foi a jogadora sub 20 número 1 do Brasil. Fez parte da
            equipe brasileira que disputou as Olimpíadas da FIDE e é atleta da Equipe Futuros
            Olímpicos da CBX.
          </p>
          <div className="cs-about__stats">
            <div className="cs-about__stat">
              <div className="cs-about__stat-value">5</div>
              <div className="cs-about__stat-label">Aulas</div>
            </div>
            <div className="cs-about__stat">
              <div className="cs-about__stat-value">800–1700</div>
              <div className="cs-about__stat-label">Rating alvo</div>
            </div>
            <div className="cs-about__stat">
              <div className="cs-about__stat-value">MN</div>
              <div className="cs-about__stat-label">Mestre Nacional</div>
            </div>
          </div>
        </div>
      </section>

      {/* Lessons */}
      <section className="cs-lessons">
        <h2 className="cs-lessons__title">O que Você Vai Aprender</h2>
        <p className="cs-lessons__subtitle">
          Ideal para jogadores com rating online de 800 a 1700 no Lichess ou Chess.com
        </p>
        <div className="cs-lessons__list">
          {lessons.map((lesson, idx) => (
            <div key={idx} className="cs-lessons__item">
              <span className="cs-lessons__number">{idx + 1}</span>
              <span className="cs-lessons__name">{lesson}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Features */}
      <section className="cs-features">
        <h2 className="cs-features__title">O que você recebe</h2>
        <div className="cs-features__grid">
          <div className="cs-features__item">
            <span className="cs-features__icon">&#127916;</span>
            <div>
              <div className="cs-features__text-title">Videoaulas com MN Isabella Conti</div>
              <div className="cs-features__text-desc">Conteúdo prático e direto ao ponto</div>
            </div>
          </div>
          <div className="cs-features__item">
            <span className="cs-features__icon">&#9854;</span>
            <div>
              <div className="cs-features__text-title">Acesso Vitalício</div>
              <div className="cs-features__text-desc">Estude no seu ritmo, sem prazo para expirar</div>
            </div>
          </div>
          <div className="cs-features__item">
            <span className="cs-features__icon">&#127942;</span>
            <div>
              <div className="cs-features__text-title">Certificado de Conclusão</div>
              <div className="cs-features__text-desc">Receba certificado ao finalizar o curso</div>
            </div>
          </div>
          <div className="cs-features__item">
            <span className="cs-features__icon">&#128241;</span>
            <div>
              <div className="cs-features__text-title">Acesse de Qualquer Lugar</div>
              <div className="cs-features__text-desc">Computador, tablet ou celular</div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="cs-testimonials">
        <h2 className="cs-testimonials__title">Depoimentos de quem já fez</h2>
        <div className="cs-testimonials__grid">
          {testimonials.map((t, idx) => (
            <div key={idx} className="cs-testimonials__card">
              <p className="cs-testimonials__text">{t.text}</p>
              <div className="cs-testimonials__name">{t.name}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="cs-final-cta">
        <h2 className="cs-final-cta__title">Comece a Evoluir Agora</h2>
        <p className="cs-final-cta__subtitle">
          5 aulas práticas com a Mestre Nacional Isabella Conti
        </p>
        <div className="cs-final-cta__price-old">De R$293,00</div>
        <div className="cs-final-cta__price">{formatPrice(course.price)}</div>
        <p className="cs-final-cta__installments">
          ou {formatInstallments(course.price)}
        </p>
        <a href={paymentUrl} target="_blank" rel="noopener noreferrer" className="cs-final-cta__btn">
          Comprar Agora
        </a>
      </section>

      {/* Trust */}
      <section className="cs-trust">
        <div className="cs-trust__grid">
          <div className="cs-trust__item">
            <div className="cs-trust__icon-badge">&#128274;</div>
            <div className="cs-trust__item-title">Pagamento Seguro</div>
            <div className="cs-trust__item-text">Seus dados protegidos com criptografia</div>
          </div>
          <div className="cs-trust__item">
            <div className="cs-trust__icon-badge">&#9889;</div>
            <div className="cs-trust__item-title">Acesso Imediato</div>
            <div className="cs-trust__item-text">Comece a estudar logo após o pagamento</div>
          </div>
          <div className="cs-trust__item">
            <div className="cs-trust__icon-badge">&#128176;</div>
            <div className="cs-trust__item-title">7 Dias de Garantia</div>
            <div className="cs-trust__item-text">Devolução integral se não ficar satisfeito</div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default CincoSegredosPage;
